<template>
  <div :id="id" :class="className" ref="echarts" :style="{ height: height, width: width }" />
</template>

<script>
const echarts = require("echarts");

export default {
  props: {
    className: {
      type: String,
      default: "chart",
    },
    id: {
      type: String,
      default: "pie-chart",
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    option: {
      type: Array,
      default:[0,0]
    },
    type:String
  },
  data() {
    return {
      myChart: null,
    };
  },
  mounted() {
    let myChart = echarts.init(this.$refs.echarts);
        this.myChart = myChart;
        let option = {
            xAxis: {
                type: "category",
                data: ["本期", this.type=='chain'?'上期':"同期"],
            },
            tooltip: {
                trigger: "axis",
                axisPointer: {
                type: "shadow",
                },
            },
            yAxis: {
                type: "value",
            },
            grid: {
                left: "0%",
                right: "10%",
                bottom: "1%",
                top: "10%",
                containLabel: true,
            },
            series: [
                {
                data: [
                    {
                    value: this.option[1].toFixed(2),
                    itemStyle: {
                        color: "#5B8FF9",
                    },
                    },
                    {
                    value: this.option[0].toFixed(2),
                    itemStyle: {
                        color: "#5AD8A6",
                    },
                    },
                ],
                type: "bar",
                },
            ],
        };
        this.myChart.setOption(option,true);

        window.addEventListener("resize", () => {
            this.myChart.resize();
        });
  },
  methods: {
    
  },
  watch: {
    option: function(newData, oldData) {
      this.myChart.clear()
        let option = {
            xAxis: {
                type: "category",
                data: ["本期", "同期"],
            },
            tooltip: {
                trigger: "axis",
                axisPointer: {
                type: "shadow",
                },
            },
            yAxis: {
                type: "value",
                // max:function(value) {
                //     return value.max*2
                // }
            },
            grid: {
                left: "0%",
                right: "10%",
                bottom: "1%",
                top: "10%",
                containLabel: true,
            },
            series: [
                {
                data: [
                    {
                    value: this.option[1].toFixed(2),
                    itemStyle: {
                        color: "#5B8FF9",
                    },
                    },
                    {
                    value: this.option[0].toFixed(2),
                    itemStyle: {
                        color: "#5AD8A6",
                    },
                    },
                ],
                type: "bar",
                },
            ],
        };
		this.myChart.setOption(option,true);
    },
  },
};
</script>
